module.exports = __webpack_public_path__ + "img/Rich_Morris@2x.413c4837.webp";